
import {SlotWinPresenter} from 'slot-win-presenter';
import {Animation} from 'animation';

export default class JapanPresenter extends SlotWinPresenter {

    constructor(slotMath, config, delegate) {

        super(slotMath, config, delegate);

    };

    terminate () {

        super.terminate();

    };

    showAnimationOnLine(line, done) {
        const symbols_positions_count = this._config.barrel.rows * this._config.barrel.reels;
        const winPos = this._slotMath.lineWinPositions(line);

        for (let i = 0; i < winPos.length; ++i) {
            let symbolId = this._slotMath.slotSymbols()[winPos[i]];
            let anim = this._symbolAnimation[symbolId * symbols_positions_count + winPos[i]];
            anim.loop = false;
            anim.visible = true;

            if (i === 0) {
                anim.onComplete = () => {
                    if (done) {
                        done();
                    }
                }
            }

            anim.gotoAndPlay(0);
        }
    };

    hideAnimationOnLine(line) {
        const symbols_positions_count = this._config.barrel.rows * this._config.barrel.reels;
        const winPos = this._slotMath.lineWinPositions(line);

        for (let i = 0; i < winPos.length; ++i) {
            let symbolId = this._slotMath.slotSymbols()[winPos[i]];
            let anim = this._symbolAnimation[symbolId * symbols_positions_count + winPos[i]];
            anim.visible = false;
            anim.onComplete = null;
            anim.stop();
        }
    };

    showScatterAnimation(infinity = false, done) {

        const symbols_positions_count = this._config.barrel.rows * this._config.barrel.reels;
        const scatterPos = this._slotMath.scatterPositions();
        let assignCallback = false;

        for (let i = 0; i < scatterPos.length; ++i) {

            let symbolId = this._slotMath.slotSymbols()[scatterPos[i]];
            let anim = this._symbolAnimation[symbolId * symbols_positions_count + scatterPos[i]];
            anim.visible = true;

            if (infinity) {
                anim.loop = true;
            }
            else {
                anim.loop = false;
                if ((symbolId === this._slotMath.scatter || i === scatterPos.length - 1) && !assignCallback) {
                    assignCallback = true;
                    anim.onComplete = () => {
                        if (done) {
                            done();
                        }
                    }
                }
            }

            anim.gotoAndPlay(0);
        }
    };

    hideScatterAnimation() {
        const symbols_positions_count = this._config.barrel.rows * this._config.barrel.reels;
        const scatterPos = this._slotMath.scatterPositions();

        for (let i = 0; i < scatterPos.length; ++i) {
            let symbolId = this._slotMath.slotSymbols()[scatterPos[i]];
            let anim = this._symbolAnimation[symbolId * symbols_positions_count + scatterPos[i]];
            anim.visible = false;
            anim.onComplete = null;
            anim.stop();
        }
    };

    showBonusAnimationInfinity() {
        let pos = this._slotMath.bonusSymbolPositions().slice();
        const symbols_positions_count = this._config.barrel.rows * this._config.barrel.reels;

        for (let i = 0; i < pos.length; ++i) {
            let anim = this._symbolAnimation[this._slotMath.bonus * symbols_positions_count + pos[i]];
            anim.visible = true;
            anim.loop = true;
            anim.gotoAndPlay(0);
        }
    };

    stopBonusAnimation() {
        let pos = this._slotMath.bonusSymbolPositions().slice();
        const symbols_positions_count = this._config.barrel.rows * this._config.barrel.reels;

        for (let i = 0; i < pos.length; ++i) {
            let animBonus = this._symbolAnimation[this._slotMath.bonus * symbols_positions_count + pos[i]];
            animBonus.visible = false;
            animBonus.onComplete = null;
            animBonus.gotoAndStop(0);
        }
    }

    startSymbolsAnimation() {

    };

    stopSymbolsAnimation() {

        const winLines = this._slotMath.winLines();
        for (let i = 0; i < winLines.length; ++i) {
            this.hideAnimationOnLine(winLines[i]);
        }

        if (this._slotMath.scatterWin() > 0) {
            this.hideScatterAnimation();
        }
    };

    /**
     * Starts win show process.
     * @param {Object} slotPresenter this
     * @param {Object} math Mathematics as data source to show wins properly
     * @memberOf japanPresenter
     * */
    showWin(slotPresenter, math) {

        this.showWinInterrupted = false;

        let winLines = math.winLines();

        let currentLineId = () => {
            return winLines[lineIdx];
        };

        let lineIdx = 0;

        let firstTime = true;

        let nextLineId = () => {
            lineIdx++;
            if (lineIdx >= winLines.length) {
                if (firstTime) {
                    if (this.delegate && this.delegate.startSecondaryShowWin) this.delegate.startSecondaryShowWin();
                }
                firstTime = false;
                lineIdx = 0;
            }
            return winLines[lineIdx];
        };

        this.timeID = null;

        let showScattersWin = () => {

            if (this.showWinInterrupted) return;

            if (this.delegate) {
                this.delegate.scattersDidShow(math.scatterWin(), firstTime);
            }

            if (winLines.length > 0) {
                this.showScatterAnimation(false, () => {

                    if (this.delegate) this.delegate.scattersDidHide();
                    this.hideScatterAnimation();
                    this.hideScatterFrames();

                    nextLineId();

                    showLinesOneByOne();
                });
            }
            else {
                //this.showScatterAnimation(true);
                this.showScatterAnimation(false, () => {
                    if (firstTime) {
                        if (this.delegate && this.delegate.startSecondaryShowWin) this.delegate.startSecondaryShowWin();
                    }
                    firstTime = false;
                    if (this.delegate) this.delegate.scattersDidShow(math.scatterWin(), false);
                    this.showScatterAnimation(true);
                });
            }
        };

        let showNextLine = () => {

            if (this.showWinInterrupted) return;

            let currentLine = currentLineId();

            // если показали последнюю линию и есть скаттеры
            if (lineIdx === winLines.length - 1 && math.scatterWin() > 0) {

                this.hideAnimationOnLine(currentLine);

                slotPresenter.hideActiveBillets(currentLine);
                slotPresenter.hideCroppedLine(currentLine, math.lineWinPositions(currentLine));

                if (this.delegate) this.delegate.lineDidHide(currentLine, firstTime);

                this.timeID = setTimeout(function() {
                    showScattersWin();
                    // nextLineId();
                }, 500);
            }
            else {
                let nextLine = nextLineId();

                if (currentLine !== nextLine) {

                    this.hideAnimationOnLine(currentLine)

                    slotPresenter.hideActiveBillets(currentLine);
                    slotPresenter.hideCroppedLine(currentLine, math.lineWinPositions(currentLine));

                    if (this.delegate) this.delegate.lineDidHide(currentLine);

                    slotPresenter.showActiveBillets(nextLine);
                    slotPresenter.showCroppedLine(nextLine, math.lineWinPositions(nextLine));

                    if (this.delegate) {
                        this.delegate.lineDidShow(nextLine, math.lineWin(nextLine), firstTime);
                    }

                    this.showAnimationOnLine(nextLine, showNextLine);

                }
            }
        };

        let showSingleLine = () => {
            this.hideAnimationOnLine(currentLineId())
            if (this.showWinInterrupted) return;

            if (this.delegate) {
                if (firstTime) {
                    if (this.delegate.startSecondaryShowWin) this.delegate.startSecondaryShowWin();
                }
                firstTime = false;
                this.delegate.lineDidShow(currentLineId(), math.lineWin(currentLineId()), false);
            }

            this.showAnimationOnLine(currentLineId(),showSingleLine)
        };

        let showLinesOneByOne = () => {

            if (this.showWinInterrupted) return;

            slotPresenter.showActiveBillets(currentLineId());
            slotPresenter.showCroppedLine(currentLineId(), math.lineWinPositions(currentLineId()));

            if (this.delegate) {
                this.delegate.lineDidShow(currentLineId(), math.lineWin(currentLineId()), firstTime);
            }

            this.showAnimationOnLine(currentLineId(), () => {
                if (winLines.length === 1 && math.scatterWin() === 0) {
                    showSingleLine();
                }
                else {
                    showNextLine();
                }
            });

        };

        let hideAllWinLines = () => {

            for (let i = 0; i < winLines.length; ++i) {
                slotPresenter.hideActiveBillets(winLines[i]);
                slotPresenter.hideLine(winLines[i]);
            }

            if (this.showWinInterrupted) return;

            this.timeID = setTimeout(showLinesOneByOne, 500/*1000*/);
        };

        let showAllWinLines = () => {

            if (this.showWinInterrupted) return;

            for (let i = 0; i < winLines.length; ++i) {
                slotPresenter.showActiveBillets(winLines[i]);
                slotPresenter.showLine(winLines[i]);
            }

            this.timeID = setTimeout(hideAllWinLines, 500/*1000*/);
        };

        if (this.delegate) this.delegate.winShowDidStart();

        //slotPresenter.startSymbolsAnimation();

        // прячем плашки
        for (let i = 0; i < this._slotMath.actualLinesNumber(); ++i) {
            slotPresenter.showInactiveBillets(i);
            slotPresenter.hideActiveBillets(i);
        }

            //если есть выигрышные линии и возможно скаттеры
        if (winLines.length > 0) {
            this.timeID = setTimeout(showAllWinLines, 300); // дадим время погаснуть плашкам
        }
            // если только скаттеры выиграли
        else if (math.scatterWin() > 0) {
            this.timeID = setTimeout(showScattersWin, 300);//
        }
    };

    /**
     * Starts win show process before extra games.
     * @param {Object} slotPresenter this
     * @param {Object} math Mathematics as data source to show wins properly
     * @param {Function} done Callback to be called on show ending
     * @memberOf japanPresenter
     * */
    showWinBeforeExtraGames(slotPresenter, math, done, freegames) {

        freegames = freegames || false;

        // ЭТУ ФУНКЦИЮ НУЖНО ЧИТАТЬ С КОНЦА ДО НАЧАЛА!!!

        this.showWinInterrupted = false;

        let winLines = math.winLines();

        let currentLineId = () => {
            return winLines[lineIdx];
        };

        let lineIdx = 0;

        let nextLineId = () => {
            lineIdx++;
            if (lineIdx >= winLines.length) {
                lineIdx = 0;
            }
            return winLines[lineIdx];
        };

        this.timeID = null;

        let finishShowWin = () => {
            if (this.delegate) {
                this.delegate.scattersDidHide();
            }
            this.interruptShowWin(slotPresenter, math, freegames);
            done();
        };

        const showBonusAnimation = () => {
            let pos = this._slotMath.bonusSymbolPositions().slice();
            const symbols_positions_count = this._config.barrel.rows * this._config.barrel.reels;

            for (let i = 0; i < pos.length; ++i) {
                let anim = this._symbolAnimation[this._slotMath.bonus * symbols_positions_count + pos[i]];
                anim.visible = true;
                anim.loop = false;
                if (i === 0) {
                    anim.onComplete  = () => {

                        this.stopBonusAnimation();
                        finishShowWin();

                    }
                }
                anim.gotoAndPlay(0);
            }

            if (this.delegate) {
               this.delegate.bonusDidShow();
            }

        };

        let showScattersWin = () => {

            if (this.showWinInterrupted) {
                return;
            }

            if (this.delegate) {
                this.delegate.scattersDidShow(math.scatterWin(), true);
            }

            this.showScatterAnimation(false, () => {

                if (this.delegate) {
                    this.delegate.scattersDidHide();
                }

                this.hideScatterAnimation();
                this.hideScatterFrames();

                showBonusAnimation();
            });

        };


        let showNextLine = () => {

            if (this.showWinInterrupted) {
                return;
            }

            let currentLine = currentLineId();

            // если показали последнюю линию и есть скаттеры
            if (lineIdx === winLines.length - 1 && (math.scatterCount() > 0 || math.hasBonus())) {
                this.hideAnimationOnLine(currentLine);
                slotPresenter.hideActiveBillets(currentLine);
                slotPresenter.hideCroppedLine(currentLine, math.lineWinPositions(currentLine));

                if (this.delegate) {
                    this.delegate.lineDidHide(currentLine, true);
                }


                if (math.scatterWin() > 0) {
                    showScattersWin();
                }
                else {
                    this.timeID = setTimeout(showBonusAnimation/*finishShowWin*/, 500);
                }
            }
            else {
                let nextLine = nextLineId();

                if (currentLine !== nextLine) {
                    this.hideAnimationOnLine(currentLine);
                    slotPresenter.hideActiveBillets(currentLine);
                    slotPresenter.hideCroppedLine(currentLine, math.lineWinPositions(currentLine));

                    if (this.delegate) {
                        this.delegate.lineDidHide(currentLine, true);
                    }

                    this.showAnimationOnLine(nextLine);
                    slotPresenter.showActiveBillets(nextLine);
                    slotPresenter.showCroppedLine(nextLine, math.lineWinPositions(nextLine));

                    if (this.delegate) {
                        this.delegate.lineDidShow(nextLine, math.lineWin(nextLine), true);
                    }

                    this.showAnimationOnLine(nextLine, showNextLine);
                }
            }
        };

        let showLinesOneByOne = () => {

            if (this.showWinInterrupted) {
                return;
            }

            slotPresenter.showActiveBillets(currentLineId());
            slotPresenter.showCroppedLine(currentLineId(), math.lineWinPositions(currentLineId()));

            if (this.delegate) {
                this.delegate.lineDidShow(currentLineId(), math.lineWin(currentLineId()), true);
            }

            this.showAnimationOnLine(currentLineId(), () => {
                if (winLines.length === 1 && math.scatterWin() === 0) {
                    showBonusAnimation();
                }
                else {
                    showNextLine();
                }
            });

        };

        let hideAllWinLines = () => {

            for (let i = 0; i < winLines.length; ++i) {
                slotPresenter.hideActiveBillets(winLines[i]);
                slotPresenter.hideLine(winLines[i]);
            }

            if (this.showWinInterrupted) {
                return;
            }

            self.timeID = setTimeout(showLinesOneByOne, 1000);
        };

        // первая функция в цепочке показа выигрыша
        let showAllWinLines = () => {

            if (this.showWinInterrupted) {
                return;
            }

            for (let i = 0; i < winLines.length; ++i) {
                slotPresenter.showActiveBillets(winLines[i]);
                slotPresenter.showLine(winLines[i]);
            }

            this.timeID = setTimeout(hideAllWinLines, 1000);
        };


        // начало показа выигрыша (все что было до этого это приватные функции частей показа выигрыша)
        if (this.delegate) this.delegate.winShowDidStart(freegames);


        //slotPresenter.startSymbolsAnimation();

        // прячем плашки
        for (let i = 0; i < this._slotMath.actualLinesNumber(); ++i) {
            slotPresenter.showInactiveBillets(i);
            slotPresenter.hideActiveBillets(i);
        }

        //если есть выигрышные линии и возможно скаттеры
        if (winLines.length > 0) {
            this.timeID = setTimeout(showAllWinLines, 300); // дадим время погаснуть плашкам перед показом всех выигрышных линий
        }
        // если только скаттеры выиграли
        else if (math.scatterWin() > 0) {
            this.timeID = setTimeout(showScattersWin, 500);
        }
        else if (math.hasBonus()) {
            // если выпал бонус при осуствии выигрыша за спин, тогда просто ждем конца анимации
            this.timeID = setTimeout(showBonusAnimation/*finishShowWin*/, 500);
        }
    };

}


// WEBPACK FOOTER //
// ./src/japan-presenter.es6